<script>
export default {
    props: ["href", "start", "title"],
    data() {
        return {
            courseInfo: {
                href: this.href,
                start: this.start,
                title: this.title,
            },
        };
    },
    methods: {},
};
</script>

<style src="./RoSignUp.scss"></style>
<template src="./RoSignUp.html"></template>



// WEBPACK FOOTER //
// RoSignUp.vue?1152930d